import { REVENUE_INTELLIGENCE_HOME_PATH } from "@/revenue-intelligence/lib/revenue-intelligence-routes";

const protectedPathPrefixes = [
  "/home",
  "/state-of-sales",
  "/revenue-intelligence/",
  "/dashboard/",
  "/reports",
  "/plans",
  "/quotas",
  "/deals",
  "/users",
  "/teams",
  "/currencies",
  "/integrations",
];

export function getMagicLinkRedirectUrl({
  currentPath,
  currentSearch,
  siteUrl,
}: {
  currentPath: string;
  currentSearch: string;
  siteUrl: string;
}) {
  const preserveDeepLink = protectedPathPrefixes.some(prefix => (
    currentPath === prefix || currentPath.startsWith(prefix)
  ));
  const targetPath = preserveDeepLink
    ? `${currentPath}${currentSearch}`
    : REVENUE_INTELLIGENCE_HOME_PATH;
  return new URL(targetPath, siteUrl).toString();
}

export function getAuthenticatedDefaultPath({
  commissionsAccess,
  currentPath,
  revenueIntelligenceAccess,
}: {
  commissionsAccess: boolean;
  currentPath: string;
  revenueIntelligenceAccess: boolean;
}) {
  if (currentPath === REVENUE_INTELLIGENCE_HOME_PATH && !revenueIntelligenceAccess) {
    return commissionsAccess ? "/dashboard" : null;
  }
  if (currentPath !== "/" && currentPath !== "/dashboard") return null;
  if (revenueIntelligenceAccess) return REVENUE_INTELLIGENCE_HOME_PATH;
  return commissionsAccess ? "/dashboard" : null;
}

export function getCleanAuthenticatedBrowserUrl(url: URL) {
  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ""));
  const hasAuthHash = [
    "access_token",
    "refresh_token",
    "expires_at",
    "expires_in",
    "token_type",
    "type",
    "error",
    "error_code",
    "error_description",
  ].some(key => hashParams.has(key));
  const clean = new URL(url.toString());
  if (hasAuthHash) clean.hash = "";
  ["code", "token_hash"].forEach(key => clean.searchParams.delete(key));
  return `${clean.pathname}${clean.search}${clean.hash}`;
}
